module.exports = __webpack_public_path__ + "static/media/VestasSans-Book.a97cf644.eot";